import { render, staticRenderFns } from "./JDAllianceAuthorization.vue?vue&type=template&id=3d7361b1"
import script from "./JDAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./JDAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7361b1')) {
      api.createRecord('3d7361b1', component.options)
    } else {
      api.reload('3d7361b1', component.options)
    }
    module.hot.accept("./JDAllianceAuthorization.vue?vue&type=template&id=3d7361b1", function () {
      api.rerender('3d7361b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/JDAllianceAuthorization.vue"
export default component.exports